<template>
  <div class="exam-template-container">
    <div class="header">
      <h2>组卷模板</h2>
      <el-button type="primary" icon="el-icon-plus" @click="setyourself">自定义组卷</el-button>
      <el-button type="primary" icon="el-icon-plus" @click="addTemplate">新增模板</el-button>
    </div>
    <el-row :gutter="20">
      <el-col :span="8" v-for="(tpl, idx) in templates" :key="tpl.id">
        <el-card class="template-card">
          <div class="card-header">
            <span class="template-title">{{ tpl.name }}</span>
            <el-button type="text" icon="el-icon-delete" @click="removeTemplate(idx)"></el-button>
          </div>
          <div class="template-info">
            <div v-for="item in tpl.items" :key="item.type">
              {{ item.label }}：{{ item.count }}道
            </div>
            <div>难度：{{ tpl.difficulty }}</div>
          </div>
          <el-button type="primary" size="mini" @click="useTemplate(tpl)">使用模板</el-button>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: 'ExamTemplate',
  data() {
    return {
      templates: [
        {
          id: 1,
          name: '基础练习',
          items: [
            { type: 1, label: '选择题', count: 50 },
            { type: 2, label: '填空题', count: 10 }
          ],
          difficulty: '简易'
        },
        {
          id: 2,
          name: '综合测试',
          items: [
            { type: 1, label: '选择题', count: 10 },
            { type: 2, label: '填空题', count: 5 },
            { type: 4, label: '简答题', count: 5 }
          ],
          difficulty: '中等'
        }
      ]
    }
  },
  methods: {
    setyourself() {
    //   this.$message.info('自定义组卷功能待实现')
      this.$router.push({ name: 'exam-question' })
    },
    addTemplate() {
      this.$message.info('新增模板功能待实现')
    },
    removeTemplate(idx) {
      this.templates.splice(idx, 1)
    },
    useTemplate(tpl) {
      this.$message.success(`使用模板：${tpl.name}`)
    }
  }
}
</script>

<style scoped>
.exam-template-container {
  padding: 30px;
}
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
}
.template-card {
  margin-bottom: 20px;
}
.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}
.template-title {
  font-weight: bold;
  font-size: 18px;
}
.template-info {
  margin-bottom: 10px;
  color: #606266;
}
</style>
